import styled from "styled-components";
import { responsive } from "Styles/Constants";
import { COLORS } from "Styles/Constants";


//IMAGES
import HeroTopVector from "../../Assets/Images/LandingPage/hero_top_vector.svg";
import HeroBottomVector from "../../Assets/Images/LandingPage/hero_bottom_vector.svg";


export const HeroContainer = styled.div`
  .hero_banner_section {
    background-color: #FFF9EB;
    padding: 70px 0px;
    position: relative;
    background-position: center center;
    background-size: 100%;
    background-repeat: no-repeat;
    
        &:before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            width: 100%;
            height: 100%;
            background: url(${HeroTopVector}) no-repeat;
            background-size: 320px;
            background-position: top right;
        }

        &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: url(${HeroBottomVector}) no-repeat;
            background-size: 475px;
            background-position: bottom left;
        }
        .mygrid-container{
            z-index:1;
            position: relative;
            .mygrid-row {
                align-items: center; 
            }
        }
        .hero_contents{
            max-width:625px;
        }
        br{
            display:none;
        }
        
  }
    @media (max-width: 991px) {
        .hero_banner_section .mygrid-row {
            flex-direction: column-reverse;
            justify-content: center;
            text-align: center;
        }
        .hero_banner_section .hero_contents {
            max-width: 100% !important;
            text-align: center;
        }
        .hero_banner_section img {
            margin-bottom: 50px;
        }
        .hero_banner_section br {
            display: block;
        }
    }
    @media (max-width: 767px) {
        .hero_banner_section .hero_contents {
            max-width: 600px;
            margin-bottom: 25px;
        }
        .hero_banner_section {
            text-align: center;
            padding: 50px 0;
        }
         .hero_banner_section:before {
            background-size: 201px;
        }
        .hero_banner_section:after {
            background-size: 350px;
        }
             .hero_banner_section img {
            margin-bottom: 20px;
        }
    } 

`;

